import { render, staticRenderFns } from "./custom_instructions_preview_modal.vue?vue&type=template&id=2808ea07&scoped=true&"
import script from "./custom_instructions_preview_modal.vue?vue&type=script&lang=js&"
export * from "./custom_instructions_preview_modal.vue?vue&type=script&lang=js&"
import style0 from "./custom_instructions_preview_modal.vue?vue&type=style&index=0&id=2808ea07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808ea07",
  null
  
)

export default component.exports